export default __webpack_public_path__ + "static/media/la-solid-900.279f3860.ttf";